import { IWebsite } from '../interfaces/huWebsite';

const websites: IWebsite[] = [
  {
    code: 'AM',
    hostnames: ['altomincio.huopenair.com'],
    title: 'Altomincio Family Park',
    properties: ['AM'],
    showAvailabilityCategory: true,
    languages: ['en', 'it', 'de', 'nl', 'fr', 'pl'],
    logo: {
      path: 'logo_HU.jpg',
      width: '70',
      height: '70'
    }
  },
  {
    code: 'NG',
    hostnames: ['norcenni.huopenair.com'],
    title: 'Norcenni Girasole',
    properties: ['NG'],
    showAvailabilityCategory: true,
    languages: ['en', 'it', 'de', 'nl', 'fr', 'pl'],
    logo: {
      path: 'logo_HU.jpg',
      width: '70',
      height: '70'
    }
  },
  {
    code: 'PA',
    hostnames: ['parkalbatros.huopenair.com'],
    title: 'Park Albatros Village',
    properties: ['PA'],
    showAvailabilityCategory: true,
    languages: ['en', 'it', 'de', 'nl', 'fr', 'pl'],
    logo: {
      path: 'logo_HU.jpg',
      width: '70',
      height: '70'
    }
  },
  {
    code: 'MS',
    hostnames: ['montescudaio.huopenair.com'],
    title: 'Montescudaio Village',
    properties: ['MS'],
    showAvailabilityCategory: true,
    languages: ['en', 'it', 'de', 'nl', 'fr', 'pl'],
    logo: {
      path: 'logo_HU.jpg',
      width: '70',
      height: '70'
    }
  },
  {
    code: 'HU',
    hostnames: [
      'huopenair.com',
      'www.huopenair.com',
      'victorious-beach-0a321c803.3.azurestaticapps.net',
      'test.huopenair.com',
      '127.0.0.1'
    ],
    title: 'HuOpen Air',
    properties: ['AM', 'NG', 'PA', 'MS'],
    showAvailabilityCategory: true,
    languages: ['en', 'it', 'de', 'nl', 'fr', 'pl'],
    logo: {
      path: 'logo_HU.jpg',
      width: '70',
      height: '70'
    }
  },
  {
    code: 'VP',
    hostnames: [
      'palagina.it',
      'www.palagina.it',
      'test.palagina.it',
      'palagina.azurewebsites.net',
      'localhost',
    ],
    title: 'Villa Palagina',
    properties: ['LC', 'VP'],
    showAvailabilityCategory: true,
    languages: ['en', 'it', 'de', 'nl', 'fr'],
    logo: {
      path: 'logo_VP.svg',
      width: '70',
      height: '70'
    }
  },
  {
    code: 'EV',
    hostnames: ['humantravel.com'],
    title: 'Human Travel',
    properties: ['AM', 'NG', 'PA'],
    showAvailabilityCategory: false,
    languages: ['en', 'it', 'de', 'nl', 'fr', 'pl', 'hu', 'da'],
    logo: {
      path: 'logo_HU.jpg',
      width: '70',
      height: '70'
    }
  }
];

export default websites;
